import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Auth from "./auth";
import Users from "./Users";
import Selector from "./Selector";
import FirstPage from "./FirstPage";
import DeviceCheck from "./utils/device-check/DeviceCheck";

function App() {
  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <Auth>
              <DeviceCheck>
                <Selector />
              </DeviceCheck>
            </Auth>
          }
        />
        <Route path="/auth" element={<FirstPage />} />
        <Route
          path="/users"
          element={
            <Auth>
              <DeviceCheck>
                <Users />
              </DeviceCheck>
            </Auth>
          }
        />
        <Route
          path="/selector"
          element={
            <Auth>
              <DeviceCheck>
                <Selector />
              </DeviceCheck>
            </Auth>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
